/* MTW konto-univers: ordrer (foldet til 4 + "Se flere") og profil-selvbetjening
   (navn/telefon + adresser) via App Proxy. ALT holdes i eget univers — ingen
   links til Shopify's hostede konto-sider: ordre-detalje/tracking vises i egen
   modal, og fejl-tilstande tilbyder "Prøv igen" i stedet for native fallback. */
(function () {
  'use strict';

  var followMode = window.location.hash === '#indleveringer';
  var followLogin = document.querySelector('[data-mtw-follow-login]');
  if (followMode && followLogin) {
    document.querySelector('[data-mtw-follow-login-heading]').textContent = 'Følg min samling';
    document.querySelector('[data-mtw-follow-login-text]').textContent = 'Log ind med den e-mail, du brugte ved indleveringen. Så finder vi dine samlinger og viser status, tilbud og historik.';
    followLogin.href = '/customer_authentication/login?return_to=' + encodeURIComponent('/pages/konto#indleveringer');
    followLogin.textContent = 'Log ind og følg min samling';
  }
  function showFollowSection() {
    var section = document.querySelector('[data-mtw-konto-tradein]');
    if (!section) return;
    section.hidden = false;
    if (followMode) requestAnimationFrame(function () { section.scrollIntoView({block:'start'}); section.focus({preventScroll:true}); });
  }
  function followError() {
    var holder = document.querySelector('[data-mtw-konto-tradein-liste]');
    if (!holder) return;
    holder.innerHTML = '<p>Vi kunne ikke hente dine indleveringer lige nu.</p><button type="button" class="mtw-konto__cta" data-mtw-follow-retry>Prøv igen</button>';
    holder.querySelector('[data-mtw-follow-retry]').addEventListener('click', hentEkstra);
    showFollowSection();
  }

  var PROXY = '/apps/portal/binders/konto';
  var VIS_FOERST = 4;

  var ordreHolder = document.querySelector('[data-mtw-konto-ordrer]');
  var profilHolder = document.querySelector('[data-mtw-konto-profil]');
  if (!ordreHolder && !profilHolder) return;

  function esc(s) {
    return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }

  function datoDa(iso) {
    try {
      return new Date(iso).toLocaleDateString('da-DK', { day: 'numeric', month: 'short', year: 'numeric' });
    } catch (e) {
      return '';
    }
  }

  function prisDa(amount, currency) {
    try {
      return new Intl.NumberFormat('da-DK', {
        style: 'currency',
        currency: currency || 'DKK',
        minimumFractionDigits: Number(amount) % 1 === 0 ? 0 : 2
      }).format(Number(amount));
    } catch (e) {
      return amount + ' kr';
    }
  }

  /* ---------- Ordrer ---------- */
  function renderOrdrer(orders) {
    if (!ordreHolder) return;
    if (!orders.length) {
      ordreHolder.innerHTML =
        '<div class="mtw-konto__tom">Ingen ordrer endnu — din første fangst venter 👀<br>' +
        '<a href="/">Udforsk shoppen →</a></div>';
      return;
    }
    var html = orders
      .map(function (o, i) {
        var billedeUrl = o.image ? o.image + (o.image.indexOf('?') > -1 ? '&' : '?') + 'width=112' : null;
        var billede = billedeUrl
          ? '<img class="mtw-konto__ordre-billede" src="' + esc(billedeUrl) + '" alt="" loading="lazy">'
          : '<span class="mtw-konto__ordre-billede mtw-konto__ordre-billede--tom" aria-hidden="true">🃏</span>';
        var meta = [datoDa(o.date), o.items === 1 ? '1 vare' : o.items + ' varer'].filter(Boolean).join(' · ');
        var skjult = i >= VIS_FOERST ? ' mtw-konto__ordre--skjult' : '';
        return (
          '<button type="button" class="mtw-konto__ordre' + skjult + '" data-ordre-id="' + esc(o.id || '') + '" aria-haspopup="dialog">' +
          billede +
          '<span class="mtw-konto__ordre-info">' +
          '<span class="mtw-konto__ordre-navn">' + esc(o.name) + '</span>' +
          '<span class="mtw-konto__ordre-meta">' + esc(meta) + '</span>' +
          '</span>' +
          '<span class="mtw-konto__ordre-hojre">' +
          '<span class="mtw-konto__pill mtw-konto__pill--' + esc(o.tone) + '">' + esc(o.status) + '</span>' +
          '<span class="mtw-konto__ordre-total">' + esc(prisDa(o.total, o.currency)) + '</span>' +
          '</span>' +
          '</button>'
        );
      })
      .join('');
    ordreHolder.innerHTML = html;
    ordreHolder.querySelectorAll('[data-ordre-id]').forEach(function (el) {
      el.addEventListener('click', function () { aabnOrdre(el.getAttribute('data-ordre-id')); });
    });
    if (orders.length > VIS_FOERST) {
      var knap = document.createElement('button');
      knap.type = 'button';
      knap.className = 'mtw-konto__mere';
      knap.textContent = 'Se flere ordrer (' + (orders.length - VIS_FOERST) + ')';
      knap.addEventListener('click', function () {
        ordreHolder.querySelectorAll('.mtw-konto__ordre--skjult').forEach(function (el) {
          el.classList.remove('mtw-konto__ordre--skjult');
        });
        knap.remove();
      });
      ordreHolder.appendChild(knap);
    }
  }

  /* ---------- Dine fangster + samler-rang + Store Credit-bevægelser ---------- */
  /* Poké Ball i mtw-streg (inline SVG — der findes ingen pokeball-emoji).
     Rang-progression = ball-progression: Poké -> Great -> Ultra -> Master -> guld. */
  function ball(farve) {
    return '<svg class="mtw-ball" viewBox="0 0 24 24" aria-hidden="true" focusable="false">' +
      '<circle cx="12" cy="12" r="10.5" fill="#fff" stroke="#1a1a1a" stroke-width="2"/>' +
      '<path d="M1.5 12a10.5 10.5 0 0 1 21 0z" fill="' + farve + '" stroke="#1a1a1a" stroke-width="2"/>' +
      '<line x1="1.5" y1="12" x2="22.5" y2="12" stroke="#1a1a1a" stroke-width="2"/>' +
      '<circle cx="12" cy="12" r="3.4" fill="#fff" stroke="#1a1a1a" stroke-width="2"/>' +
      '</svg>';
  }
  /* Flere ikoner i samme streg: dex, holo-kort m. sparkle, pakke m. gul tape, lyn. */
  function dexIkon() {
    return '<svg class="mtw-ball" viewBox="0 0 24 24" aria-hidden="true" focusable="false">' +
      '<rect x="3" y="2" width="18" height="20" rx="2.5" fill="#e94b4b" stroke="#1a1a1a" stroke-width="2"/>' +
      '<circle cx="7.4" cy="6.3" r="2.5" fill="#9fd9ff" stroke="#1a1a1a" stroke-width="1.5"/>' +
      '<circle cx="12.8" cy="4.8" r="0.95" fill="#FFCB03" stroke="#1a1a1a" stroke-width="1"/>' +
      '<circle cx="15.8" cy="4.8" r="0.95" fill="#9fd9ff" stroke="#1a1a1a" stroke-width="1"/>' +
      '<circle cx="18.6" cy="4.8" r="0.95" fill="#fff" stroke="#1a1a1a" stroke-width="1"/>' +
      '<rect x="5.8" y="10" width="12.4" height="7.4" rx="1.2" fill="#fff" stroke="#1a1a1a" stroke-width="1.5"/>' +
      '<rect x="7.6" y="11.6" width="8.8" height="4.2" rx="0.6" fill="#1a1a1a"/>' +
      '<rect x="5.8" y="19" width="4.6" height="1.9" rx="0.6" fill="#9fd9ff" stroke="#1a1a1a" stroke-width="1"/>' +
      '<circle cx="17.4" cy="19.9" r="1.25" fill="#FFCB03" stroke="#1a1a1a" stroke-width="1"/>' +
      '</svg>';
  }
  function kortIkon() {
    return '<svg class="mtw-ball" viewBox="0 0 24 24" aria-hidden="true" focusable="false">' +
      '<rect x="4.5" y="3" width="15" height="19" rx="2.5" fill="#fff" stroke="#1a1a1a" stroke-width="2"/>' +
      '<rect x="7.2" y="5.8" width="9.6" height="7" rx="1" fill="#FFCB03" stroke="#1a1a1a" stroke-width="1.5"/>' +
      '<line x1="7.5" y1="16" x2="16.5" y2="16" stroke="#1a1a1a" stroke-width="1.5"/>' +
      '<line x1="7.5" y1="19" x2="13" y2="19" stroke="#1a1a1a" stroke-width="1.5"/>' +
      '<path d="M19 1l1 2.4L22.4 4.4 20 5.4 19 7.8 18 5.4 15.6 4.4 18 3.4z" fill="#fff" stroke="#1a1a1a" stroke-width="1.3" stroke-linejoin="round"/>' +
      '</svg>';
  }
  function pakkeIkon() {
    return '<svg class="mtw-ball" viewBox="0 0 24 24" aria-hidden="true" focusable="false">' +
      '<rect x="3.5" y="6.5" width="17" height="14.5" rx="2" fill="#fff" stroke="#1a1a1a" stroke-width="2"/>' +
      '<rect x="9.8" y="6.5" width="4.4" height="14.5" fill="#FFCB03" stroke="#1a1a1a" stroke-width="1.5"/>' +
      '<path d="M3.5 8.5L6.5 3h11l3 5.5" fill="none" stroke="#1a1a1a" stroke-width="2" stroke-linejoin="round"/>' +
      '</svg>';
  }
  function bytIkon() {
    /* Byttepile — "solgt til os" (mtw-streg: 2px ink, gul accent) */
    return '<svg class="mtw-ball" viewBox="0 0 24 24" aria-hidden="true" focusable="false" fill="none" stroke="#1a1a1a" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">' +
      '<path d="M4 8h14" stroke="#FFCB03" stroke-width="3.4"/><path d="M4 8h14M15 4.5L18.5 8 15 11.5"/>' +
      '<path d="M20 16H6" stroke="#FFCB03" stroke-width="3.4"/><path d="M20 16H6M9 12.5L5.5 16 9 19.5"/>' +
      '</svg>';
  }

  function lynIkon() {
    return '<svg class="mtw-ball" viewBox="0 0 24 24" aria-hidden="true" focusable="false">' +
      '<path d="M13.5 2L5.5 13.5h5L10.5 22l8-12h-5z" fill="#FFCB03" stroke="#1a1a1a" stroke-width="2" stroke-linejoin="round"/>' +
      '</svg>';
  }
  var RANGE = [
    { navn: 'Rookie', min: 0, ikon: ball('#e94b4b') },
    { navn: 'Trainer', min: 10, ikon: ball('#3b76e0') },
    { navn: 'Gym Leader', min: 50, ikon: ball('#1a1a1a') },
    { navn: 'Elite Four', min: 150, ikon: ball('#8e4bd8') },
    { navn: 'Champion', min: 400, ikon: ball('#e0a90f') }
  ];

  function rangFor(kort) {
    var r = RANGE[0], next = null;
    for (var i = 0; i < RANGE.length; i++) {
      if (kort >= RANGE[i].min) r = RANGE[i];
      else { next = RANGE[i]; break; }
    }
    return { rang: r, next: next };
  }

  var ROLIG = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var sidsteKort = 0;

  /* Count-up: 0 -> mål med ease-out. Ved reduced-motion sættes tallet direkte. */
  function taelOp(el, maal) {
    maal = Number(maal) || 0;
    if (ROLIG || maal <= 0) { el.textContent = maal.toLocaleString('da-DK'); return; }
    var start = null, VARIGHED = 900;
    function trin(ts) {
      if (!start) start = ts;
      var t = Math.min(1, (ts - start) / VARIGHED);
      var eased = 1 - Math.pow(1 - t, 3);
      el.textContent = Math.round(maal * eased).toLocaleString('da-DK');
      if (t < 1) requestAnimationFrame(trin);
    }
    requestAnimationFrame(trin);
  }

  /* Rang-oversigt: alle ranks + krav i egen modal (Mathias-ønske: se hele stigen) */
  function aabnRangOversigt(kort) {
    lukOrdreModal();
    var ri = rangFor(kort);
    var rows = RANGE.map(function (r, i) {
      var naeste = RANGE[i + 1];
      var erNu = r === ri.rang;
      var opnaaet = kort >= r.min;
      var krav = naeste ? r.min + '–' + (naeste.min - 1) + ' kort' : r.min + '+ kort';
      var status = erNu
        ? '<span class="mtw-konto__pill mtw-konto__pill--warn">Din rang</span>'
        : opnaaet
          ? '<span class="mtw-konto__rang-ok" aria-label="Opnået">✓</span>'
          : '<span class="mtw-konto__rang-mangler">om ' + (r.min - kort) + ' kort</span>';
      return '<li class="mtw-konto__rang-rk' + (erNu ? ' mtw-konto__rang-rk--nu' : '') + (opnaaet ? '' : ' mtw-konto__rang-rk--laast') + '">' +
        '<span class="mtw-konto__rang-rk-ikon" aria-hidden="true">' + r.ikon + '</span>' +
        '<span class="mtw-konto__rang-rk-navn"><strong>' + esc(r.navn) + '</strong><span>' + krav + '</span></span>' +
        status + '</li>';
    }).join('');
    var bag = document.createElement('div');
    bag.className = 'mtw-konto__modal-bag';
    bag.innerHTML =
      '<div class="mtw-konto__modal mtw-konto__modal--rang" role="dialog" aria-modal="true" aria-label="Samler-ranks">' +
      '<button type="button" class="mtw-konto__modal-luk" aria-label="Luk">✕</button>' +
      '<header class="mtw-konto__modal-hoved"><div><h3>Samler-ranks</h3>' +
      '<span class="mtw-konto__ordre-meta">Din rang stiger med antal kort, du fanger hos os — du har ' + esc(kort) + '</span></div></header>' +
      '<ul class="mtw-konto__rang-liste">' + rows + '</ul>' +
      '</div>';
    document.body.appendChild(bag);
    bag.addEventListener('click', function (e) { if (e.target === bag) lukOrdreModal(); });
    bag.querySelector('.mtw-konto__modal-luk').addEventListener('click', lukOrdreModal);
    document.addEventListener('keydown', escLuk);
  }

  function renderStats(stats, solgtTilOs) {
    var holder = document.querySelector('[data-mtw-konto-stats]');
    if (!holder || !stats) return;
    var sektion = holder.closest('.mtw-konto__fangster');
    var kort = Number(stats.kort) || 0;
    var ri = rangFor(kort);

    /* Rang-badge i overskriften — klikbar: åbner rang-oversigten */
    var rangEl = document.querySelector('[data-mtw-konto-rang]');
    if (rangEl) {
      rangEl.hidden = false;
      rangEl.classList.add('mtw-konto__rang--pop');
      rangEl.innerHTML = ri.rang.ikon + ' ' + esc(ri.rang.navn) + ' <span aria-hidden="true">▾</span>';
      rangEl.setAttribute('role', 'button');
      rangEl.setAttribute('tabindex', '0');
      rangEl.setAttribute('aria-haspopup', 'dialog');
      rangEl.setAttribute('aria-label', 'Se alle samler-ranks');
      if (!rangEl.__mtwKlik) {
        rangEl.__mtwKlik = 1;
        rangEl.addEventListener('click', function () { aabnRangOversigt(sidsteKort); });
        rangEl.addEventListener('keydown', function (e) {
          if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); aabnRangOversigt(sidsteKort); }
        });
      }
    }
    sidsteKort = kort;

    /* XP-bar: fremgang mod næste rang (fuld bar som Champion) */
    if (sektion) {
      var gammelXp = sektion.querySelector('.mtw-konto__xp');
      if (gammelXp) gammelXp.remove();
      var pct = ri.next ? Math.max(4, Math.round(((kort - ri.rang.min) / (ri.next.min - ri.rang.min)) * 100)) : 100;
      var xpLabel = ri.next
        ? (ri.next.min - kort) + ' kort til ' + esc(ri.next.navn)
        : 'Maks rang — du ER mesteren 👑';
      var xp = document.createElement('div');
      xp.className = 'mtw-konto__xp';
      xp.innerHTML =
        '<span class="mtw-konto__xp-ikon" aria-hidden="true">' + ri.rang.ikon + '</span>' +
        '<div class="mtw-konto__xp-bar" role="progressbar" aria-valuemin="0" aria-valuemax="100" aria-valuenow="' + pct + '" aria-label="Fremgang mod næste samler-rang">' +
        '<div class="mtw-konto__xp-fyld"></div></div>' +
        '<span class="mtw-konto__xp-ikon" aria-hidden="true">' + (ri.next ? ri.next.ikon : '👑') + '</span>' +
        '<span class="mtw-konto__xp-label">' + xpLabel + '</span>';
      holder.parentNode.insertBefore(xp, holder);
      var fyld = xp.querySelector('.mtw-konto__xp-fyld');
      if (ROLIG) { fyld.style.width = pct + '%'; }
      else { requestAnimationFrame(function () { requestAnimationFrame(function () { fyld.style.width = pct + '%'; }); }); }
    }

    var siden = stats.siden ? new Date(stats.siden).getFullYear() : null;
    function statKort(ikon, vaerdi, label, i, count) {
      return '<div class="mtw-konto__stat mtw-konto__stat--pop" style="animation-delay:' + (i * 90) + 'ms">' +
        '<span class="mtw-konto__stat-ikon" aria-hidden="true">' + ikon + '</span>' +
        '<strong' + (count ? ' data-mtw-count="' + vaerdi + '"' : '') + '>' + (count ? '0' : esc(vaerdi)) + '</strong>' +
        '<span>' + label + '</span></div>';
    }
    var html =
      statKort(dexIkon(), kort, 'kort fanget', 0, true) +
      statKort(kortIkon(), stats.unikke, 'unikke kort', 1, true) +
      statKort(pakkeIkon(), stats.ordrer, 'ordrer', 2, true) +
      (siden ? statKort(lynIkon(), siden, 'samler hos os siden', 3, false) : '') +
      (Number(solgtTilOs) > 0 ? statKort(bytIkon(), prisDa(solgtTilOs, 'DKK'), 'solgt til os', 4, false) : '');
    if (stats.dyreste) {
      var d = stats.dyreste;
      var dimg = d.image
        ? '<img src="' + esc(d.image + (d.image.indexOf('?') > -1 ? '&' : '?') + 'width=96') + '" alt="" loading="lazy">'
        : '<span aria-hidden="true">💎</span>';
      html += '<div class="mtw-konto__stat mtw-konto__stat--dyreste mtw-konto__stat--pop" style="animation-delay:360ms">' + dimg +
        '<span class="mtw-konto__stat-dyreste-info"><strong>' + esc(prisDa(d.pris, 'DKK')) + '</strong>' +
        '<span>Dyreste fangst: ' + esc(d.title) + '</span></span></div>';
    }
    holder.innerHTML = html;
    holder.querySelectorAll('[data-mtw-count]').forEach(function (el) {
      taelOp(el, el.getAttribute('data-mtw-count'));
    });
  }

  function renderBevaegelser(liste) {
    var holder = document.querySelector('[data-mtw-konto-bev]');
    var toggle = document.querySelector('[data-mtw-bev-toggle]');
    if (!holder || !toggle || !liste || !liste.length) return;
    holder.innerHTML = liste.map(function (b) {
      var plus = b.type === 'ind';
      return '<div class="mtw-konto__bev-rk"><span>' + esc(datoDa(b.date)) + '</span>' +
        '<strong class="mtw-konto__bev-' + (plus ? 'ind' : 'ud') + '">' + (plus ? '+' : '') + esc(prisDa(b.belob, b.currency)) + '</strong></div>';
    }).join('');
    toggle.classList.remove('mtw-konto__bev-toggle--skjult');
    toggle.addEventListener('click', function () {
      var aaben = holder.classList.toggle('mtw-konto__bev--skjult');
      toggle.setAttribute('aria-expanded', aaben ? 'false' : 'true');
      toggle.textContent = aaben ? 'Se bevægelser ▾' : 'Skjul bevægelser ▴';
    });
  }

  /* ---------- Kunde-dashboard: indleveringer, tilbud og historik ----------
     Hver aktiv sag folder ud til en tidslinje (fra portalens statushistorik),
     tilbudsbeløb m. frist + svar-link, og gendownload af fragtlabel. Under
     de aktive: foldbar historik m. afregningskvittering. Fail-soft hele vejen. */
  var TI_METODE = { cash: 'Kontant', bank: 'Bankoverførsel', store_credit: 'Store Credit', split: 'Split' };

  function tiTrinHtml(trin) {
    if (!trin || !trin.length) return '';
    return '<ol class="mtw-konto__ti-trin">' + trin.map(function (t) {
      return '<li class="' + (t.naaet ? 'er-naaet' : '') + (t.nu ? ' er-nu' : '') + '">' +
        '<span class="mtw-konto__ti-dot" aria-hidden="true"></span>' +
        '<span class="mtw-konto__ti-navn">' + esc(t.label) + '</span>' +
        (t.dato ? '<span class="mtw-konto__ti-dato">' + esc(datoDa(t.dato)) + '</span>' : '') +
        '</li>';
    }).join('') + '</ol>';
  }

  function tiTilbudHtml(tb) {
    if (!tb) return '';
    var tekst;
    if (tb.mode === 'dual_choice' && tb.kontant != null && tb.credit != null) {
      tekst = 'Vælg: <strong>' + esc(prisDa(tb.kontant, 'DKK')) + '</strong> kontant <em>eller</em> <strong>' + esc(prisDa(tb.credit, 'DKK')) + '</strong> i Store Credit';
    } else if (tb.mode === 'split' && tb.kontant != null && tb.credit != null) {
      tekst = '<strong>' + esc(prisDa(tb.kontant, 'DKK')) + '</strong> kontant + <strong>' + esc(prisDa(tb.credit, 'DKK')) + '</strong> i Store Credit';
    } else {
      var belob = tb.kontant != null ? tb.kontant : tb.credit;
      tekst = belob != null
        ? '<strong>' + esc(prisDa(belob, 'DKK')) + '</strong>' + (tb.kontant != null ? ' kontant' : ' i Store Credit')
        : 'Se dit tilbud';
    }
    return '<div class="mtw-konto__ti-tilbud">' +
      '<span class="mtw-konto__ti-tilbud-tekst">Dit tilbud: ' + tekst + '</span>' +
      (tb.frist ? '<span class="mtw-konto__ti-note">Svar senest ' + esc(datoDa(tb.frist)) + '</span>' : '') +
      '<a class="mtw-konto__ti-knap" href="' + esc(tb.url) + '" target="_blank" rel="noopener">Svar på tilbud →</a>' +
      '</div>';
  }

  function tiLabelHtml(fl) {
    if (!fl) return '';
    return '<div class="mtw-konto__ti-fragt">' +
      '<a class="mtw-konto__ti-knap mtw-konto__ti-knap--ghost" href="' + esc(fl.url) + '" target="_blank" rel="noopener">Hent din fragtlabel (PDF)</a>' +
      (fl.tracking ? '<span class="mtw-konto__ti-note">Tracking: ' + esc(fl.tracking) + '</span>' : '') +
      '</div>';
  }

  function tiHistRk(h) {
    var afr = '';
    if (h.afregning) {
      var a = h.afregning;
      afr = (a.metode === 'split' && a.kontant != null && a.credit != null)
        ? esc(prisDa(a.kontant, 'DKK')) + ' kontant + ' + esc(prisDa(a.credit, 'DKK')) + ' Store Credit'
        : esc(prisDa(a.belob, 'DKK')) + ' · ' + esc(TI_METODE[a.metode] || a.metode);
    }
    return '<div class="mtw-konto__bev-rk mtw-konto__ti-hist-rk">' +
      '<span>' + esc(h.id) + ' · ' + esc(datoDa(h.dato)) + '</span>' +
      '<span class="mtw-konto__ti-hist-hojre">' +
      (afr ? '<strong>' + afr + '</strong>' : '') +
      '<span class="mtw-konto__pill mtw-konto__pill--' + esc(h.tone) + '">' + esc(h.status) + '</span>' +
      '</span></div>';
  }

  function renderTradein(d) {
    var sektion = document.querySelector('[data-mtw-konto-tradein]');
    var holder = document.querySelector('[data-mtw-konto-tradein-liste]');
    var liste = (d && d.tradein) || [];
    var hist = (d && d.tradeinHistorik) || [];
    if (!sektion || !holder) return;
    if (d && d.tradeinUnavailable) { followError(); return; }
    if (!liste.length && !hist.length) {
      holder.innerHTML = '<p>Ingen indleveringer fundet på denne konto.</p><p>Kontrollér, at du er logget ind med samme e-mail som ved indleveringen. Har du brugt en anden e-mail, eller mangler din sag stadig, så <a href="/pages/kontakt">kontakt os</a> med dit samlingsnummer fra kvitteringen.</p>';
      showFollowSection(); return;
    }

    holder.innerHTML = liste.map(function (t) {
      var harDetalje = (t.trin && t.trin.length) || t.tilbud || t.fragtlabel;
      var hoved =
        '<span class="mtw-konto__ordre-billede mtw-konto__ordre-billede--tom mtw-konto__tradein-ikon" aria-hidden="true">' + pakkeIkon() + '</span>' +
        '<span class="mtw-konto__ordre-info">' +
        '<span class="mtw-konto__ordre-navn">Indlevering ' + esc(t.id) + '</span>' +
        '<span class="mtw-konto__ordre-meta">Opdateret ' + esc(datoDa(t.opdateret)) + '</span>' +
        '</span>' +
        '<span class="mtw-konto__ordre-hojre">' +
        '<span class="mtw-konto__pill mtw-konto__pill--' + esc(t.tone) + '">' + esc(t.status) + '</span>' +
        (harDetalje ? '<span class="mtw-konto__ti-pil" aria-hidden="true">▾</span>' : '') +
        '</span>';
      if (!harDetalje) {
        return '<a class="mtw-konto__ordre" href="' + esc(t.tilbudUrl || 'https://tradein.matraws.dk') + '" target="_blank" rel="noopener">' + hoved + '</a>';
      }
      return '<div class="mtw-konto__ti" data-tradein-kort>' +
        '<button type="button" class="mtw-konto__ordre mtw-konto__ti-hoved" data-tradein-hoved aria-expanded="false">' + hoved + '</button>' +
        '<div class="mtw-konto__ti-detalje" hidden>' +
        tiTrinHtml(t.trin) +
        tiTilbudHtml(t.tilbud) +
        tiLabelHtml(t.fragtlabel) +
        '</div></div>';
    }).join('');

    holder.querySelectorAll('[data-tradein-kort]').forEach(function (el) {
      var knap = el.querySelector('[data-tradein-hoved]');
      var detalje = el.querySelector('.mtw-konto__ti-detalje');
      knap.addEventListener('click', function () {
        var aaben = detalje.hidden;
        detalje.hidden = !aaben;
        el.classList.toggle('mtw-konto__ti--aaben', aaben);
        knap.setAttribute('aria-expanded', aaben ? 'true' : 'false');
      });
    });

    var histToggle = document.querySelector('[data-mtw-tradein-hist-toggle]');
    var histHolder = document.querySelector('[data-mtw-konto-tradein-hist]');
    if (histToggle && histHolder && hist.length) {
      histHolder.innerHTML = hist.map(tiHistRk).join('');
      histToggle.hidden = false;
      histToggle.textContent = 'Tidligere indleveringer (' + hist.length + ') ▾';
      histToggle.addEventListener('click', function () {
        var aaben = histHolder.classList.toggle('mtw-konto__bev--skjult');
        histToggle.setAttribute('aria-expanded', aaben ? 'false' : 'true');
        histToggle.textContent = (aaben ? 'Tidligere indleveringer (' + hist.length + ') ▾' : 'Skjul tidligere indleveringer ▴');
      });
    }
    showFollowSection();
  }

  /* Dine gradings: igangværende grading-ordrer fra /apps/portal/grading.
     Fail-soft — enhver fejl (netværk, 500, {error:...} eller uventet data)
     skjuler bare sektionen; resten af siden må aldrig kunne påvirkes. Hele
     blokken er derfor pakket i try/catch, så selv en synkron fejl her ikke
     kan stoppe hent()/hentEkstra() nedenfor i filen.

     Labels SPEJLES ikke længere fra mtw-grading.js — de deles med den, fra
     assets/mtw-grading-faelles.js. Her stod før en anden kopi af den samme
     tabel, og de to drev fra hinanden: mgrading fik stadiet 'awaiting_cards',
     statussiden fik sin danske tekst, og denne side blev ved med at skrive den
     rå nøgle "awaiting_cards" ud på hver eneste nybetalt indlevering. Så
     længe teksten står to steder, kan den drive igen; nu står den ét. */
  try {
    var GR = window.MTWG_FAELLES;
    // Fail-soft som resten af blokken: uden den delte fil har vi ingen danske
    // etiketter, og en rå nøgle må aldrig nå kunden. Så vises sektionen ikke.
    if (!GR) throw new Error('mtw-grading-faelles mangler');

    var grLabel = function (o) { return GR.pille(o); };

    var renderGrading = function (d) {
      var sektion = document.querySelector('[data-mtw-konto-grading]');
      var holder = document.querySelector('[data-mtw-konto-grading-liste]');
      var liste = ((d && d.orders) || []).filter(function (o) { return o.inFlight; });
      if (!sektion || !holder || !liste.length) return;
      // tone kommer ALTID fra denne ternær — output kan kun være 'psa', 'ok'
      // eller 'neutral', uanset hvad o.ownership/o.stageKey indeholder, så en
      // rå værdi kan aldrig nå class-attributten.
      holder.innerHTML = liste.map(function (o) {
        var tone = o.ownership === 'psa' ? 'psa' : o.stageKey === 'fulfil' ? 'ok' : 'neutral';
        return '<a class="mtw-konto__ordre" href="/pages/min-grading">' +
          '<span class="mtw-konto__ordre-billede mtw-konto__ordre-billede--tom mtw-konto__tradein-ikon" aria-hidden="true">' + pakkeIkon() + '</span>' +
          '<span class="mtw-konto__ordre-info">' +
          '<span class="mtw-konto__ordre-navn">Grading ' + esc(o.ref) + '</span>' +
          '<span class="mtw-konto__ordre-meta">' + esc(o.cardCount) + ' kort' + (o.tier ? ' · ' + esc(o.tier) : '') + '</span>' +
          '</span>' +
          '<span class="mtw-konto__ordre-hojre"><span class="mtw-konto__pill mtw-konto__pill--' + tone + '">' + esc(grLabel(o)) + '</span></span>' +
          '</a>';
      }).join('');
      sektion.hidden = false;
    };

    // Sektionen findes kun for kunder med adgang; uden den spørger vi slet ikke serveren.
    if (document.querySelector('[data-mtw-konto-grading]')) fetch(GR.proxyBase(document.querySelector('[data-mtw-konto-grading]').getAttribute('data-proxy-base')), { credentials: 'same-origin' })
      .then(function (r) { return r.ok ? r.json() : null; })
      .then(function (d) { if (d && !d.error) renderGrading(d); })
      .catch(function () {});
  } catch (e) {}

  /* Din ønskeliste: back-in-stock-ønsker (alle produkttyper) — "På lager NU"
     er slået op live, så Køb-knappen aldrig lyver. */
  function renderOenskeliste(liste) {
    var sektion = document.querySelector('[data-mtw-konto-oensker]');
    var holder = document.querySelector('[data-mtw-konto-oensker-liste]');
    if (!sektion || !holder || !liste || !liste.length) return;
    holder.innerHTML = liste.map(function (o, i) {
      var billede = o.image
        ? '<img class="mtw-konto__ordre-billede" src="' + esc(o.image + (o.image.indexOf('?') > -1 ? '&' : '?') + 'width=112') + '" alt="" loading="lazy">'
        : '<span class="mtw-konto__ordre-billede mtw-konto__ordre-billede--tom" aria-hidden="true">🃏</span>';
      var skjult = i >= VIS_FOERST ? ' mtw-konto__ordre--skjult' : '';
      return '<div class="mtw-konto__ordre mtw-konto__oenske' + skjult + '" data-oenske="' + esc(o.id) + '">' +
        billede +
        '<span class="mtw-konto__ordre-info">' +
        '<span class="mtw-konto__ordre-navn">' + esc(o.title) + '</span>' +
        '<span class="mtw-konto__ordre-meta">' + (o.pris != null ? esc(prisDa(o.pris, 'DKK')) : '') + '</span>' +
        '</span>' +
        '<span class="mtw-konto__ordre-hojre">' +
        (o.paa_lager
          ? '<span class="mtw-konto__pill mtw-konto__pill--warn">På lager NU</span>' +
            '<a class="mtw-konto__knap mtw-konto__knap--kob" href="/products/' + esc(o.handle) + '">Køb →</a>'
          : '<span class="mtw-konto__pill">Vi holder øje 👀</span>') +
        '<button type="button" class="mtw-konto__lille-link" data-oenske-fjern="' + esc(o.id) + '">Fjern</button>' +
        '</span>' +
        '</div>';
    }).join('');
    if (liste.length > VIS_FOERST) {
      var mereKnap = document.createElement('button');
      mereKnap.type = 'button';
      mereKnap.className = 'mtw-konto__mere';
      mereKnap.textContent = 'Se flere ønsker (' + (liste.length - VIS_FOERST) + ')';
      mereKnap.addEventListener('click', function () {
        holder.querySelectorAll('.mtw-konto__ordre--skjult').forEach(function (el) {
          el.classList.remove('mtw-konto__ordre--skjult');
        });
        mereKnap.remove();
      });
      holder.appendChild(mereKnap);
    }
    sektion.hidden = false;
    holder.querySelectorAll('[data-oenske-fjern]').forEach(function (k) {
      k.addEventListener('click', function () {
        if (!window.confirm('Fjern fra ønskelisten?')) return;
        fetch('/apps/portal/binders', {
          method: 'POST',
          credentials: 'same-origin',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ action: 'remove', itemId: k.getAttribute('data-oenske-fjern') })
        }).then(function () {
          var rk = holder.querySelector('[data-oenske="' + k.getAttribute('data-oenske-fjern') + '"]');
          if (rk) rk.remove();
          if (!holder.children.length) sektion.hidden = true;
        });
      });
    });
  }

  function hentEkstra() {
    if (!document.querySelector('[data-mtw-konto-stats]')) return;
    fetch(PROXY + '?ekstra=1', { credentials: 'same-origin' })
      .then(function (r) { if (!r.ok) throw new Error('http ' + r.status); return r.json(); })
      .then(function (d) {
        if (d && d.error) throw new Error(d.error);
        renderStats(d && d.stats, d && d.tradeinTotal);
        renderBevaegelser(d && d.bevaegelser);
        renderTradein(d);
        renderOenskeliste(d && d.oenskeliste);
      })
      .catch(function () {
        followError();
        var holder = document.querySelector('[data-mtw-konto-stats]');
        var sektion = holder && holder.closest('.mtw-konto__fangster');
        if (sektion) sektion.style.display = 'none';
      });
  }

  /* ---------- Ordre-detalje (egen modal — aldrig hostede sider) ---------- */
  function lukOrdreModal() {
    var m = document.querySelector('.mtw-konto__modal-bag');
    if (m) m.remove();
    document.removeEventListener('keydown', escLuk);
  }
  function escLuk(e) { if (e.key === 'Escape') lukOrdreModal(); }

  function aabnOrdre(id) {
    if (!id) return;
    lukOrdreModal();
    var bag = document.createElement('div');
    bag.className = 'mtw-konto__modal-bag';
    bag.innerHTML =
      '<div class="mtw-konto__modal" role="dialog" aria-modal="true" aria-label="Ordredetaljer">' +
      '<button type="button" class="mtw-konto__modal-luk" aria-label="Luk">✕</button>' +
      '<div class="mtw-konto__modal-krop"><div class="mtw-konto__skelet" aria-hidden="true"></div><div class="mtw-konto__skelet" aria-hidden="true"></div></div>' +
      '</div>';
    document.body.appendChild(bag);
    bag.addEventListener('click', function (e) { if (e.target === bag) lukOrdreModal(); });
    bag.querySelector('.mtw-konto__modal-luk').addEventListener('click', lukOrdreModal);
    document.addEventListener('keydown', escLuk);
    var krop = bag.querySelector('.mtw-konto__modal-krop');

    fetch(PROXY + '?ordre=' + encodeURIComponent(id), { credentials: 'same-origin' })
      .then(function (r) { if (!r.ok) throw new Error('http ' + r.status); return r.json(); })
      .then(function (d) {
        var o = d && d.ordre;
        if (!o) throw new Error('tom');
        var html =
          '<header class="mtw-konto__modal-hoved">' +
          '<div><h3>' + esc(o.name) + '</h3><span class="mtw-konto__ordre-meta">' + esc(datoDa(o.date)) + (o.betaling ? ' · ' + esc(o.betaling) : '') + '</span></div>' +
          '<span class="mtw-konto__pill mtw-konto__pill--' + esc(o.tone) + '">' + esc(o.status) + '</span>' +
          '</header>';
        if (o.tracking && o.tracking.length) {
          html += '<div class="mtw-konto__track">';
          o.tracking.forEach(function (t) {
            var tekst = '📦 Følg din pakke' + (t.company ? ' (' + esc(t.company) + ')' : '') + ' →';
            html += t.url
              ? '<a class="mtw-konto__knap mtw-konto__knap--track" href="' + esc(t.url) + '" target="_blank" rel="noopener">' + tekst + '</a>'
              : '<span class="mtw-konto__ordre-meta">Trackingnr.: ' + esc(t.number) + '</span>';
          });
          html += '</div>';
        }
        html += '<ul class="mtw-konto__linjer">';
        o.linjer.forEach(function (l) {
          var img = l.image
            ? '<img src="' + esc(l.image + (l.image.indexOf('?') > -1 ? '&' : '?') + 'width=96') + '" alt="" loading="lazy">'
            : '<span class="mtw-konto__ordre-billede--tom" aria-hidden="true">🃏</span>';
          html +=
            '<li>' + img +
            '<span class="mtw-konto__linje-info"><strong>' + esc(l.title) + '</strong>' +
            (l.variant ? '<span>' + esc(l.variant) + '</span>' : '') +
            '<span>Antal: ' + esc(l.qty) + '</span></span>' +
            '<span class="mtw-konto__linje-pris">' + esc(prisDa(l.total, o.currency)) + '</span></li>';
        });
        html += '</ul>';
        html += '<dl class="mtw-konto__totaler">';
        html += '<div><dt>Subtotal</dt><dd>' + esc(prisDa(o.subtotal, o.currency)) + '</dd></div>';
        if (Number(o.rabat) > 0) html += '<div><dt>Rabat</dt><dd>−' + esc(prisDa(o.rabat, o.currency)) + '</dd></div>';
        html += '<div><dt>Fragt</dt><dd>' + (Number(o.fragt) > 0 ? esc(prisDa(o.fragt, o.currency)) : 'Gratis') + '</dd></div>';
        html += '<div class="mtw-konto__totaler-total"><dt>Total</dt><dd>' + esc(prisDa(o.total, o.currency)) + '</dd></div>';
        html += '</dl>';
        if (o.adresse && o.adresse.length) {
          html += '<div class="mtw-konto__modal-adresse"><h4>Leveres til</h4><p>' + o.adresse.map(esc).join('<br>') + '</p></div>';
        }
        html += '<p class="mtw-konto__ordre-meta mtw-konto__modal-hjaelp">Spørgsmål til ordren? Skriv til <a href="mailto:info@matraws.dk">info@matraws.dk</a> — nævn ' + esc(o.name) + '.</p>';
        krop.innerHTML = html;
      })
      .catch(function () {
        krop.innerHTML =
          '<div class="mtw-konto__tom">Kunne ikke hente ordren lige nu.<br>' +
          '<button type="button" class="mtw-konto__knap" data-provigen>Prøv igen</button></div>';
        krop.querySelector('[data-provigen]').addEventListener('click', function () { aabnOrdre(id); });
      });
  }

  /* ---------- Profil ---------- */
  function inputRk(label, name, value, attrs) {
    return (
      '<label class="mtw-konto__felt"><span>' + esc(label) + '</span>' +
      '<input name="' + esc(name) + '" value="' + esc(value || '') + '" ' + (attrs || '') + '></label>'
    );
  }

  function post(data) {
    return fetch(PROXY, {
      method: 'POST',
      credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(data)
    }).then(function (r) { return r.json(); });
  }

  function bindForm(form, byg, efter) {
    form.addEventListener('submit', function (e) {
      e.preventDefault();
      var knap = form.querySelector('button[type="submit"]');
      var fejl = form.querySelector('.mtw-konto__fejl');
      if (fejl) fejl.textContent = '';
      knap.disabled = true;
      knap.textContent = 'Gemmer…';
      post(byg(new FormData(form)))
        .then(function (r) {
          if (r && r.ok) { efter(); return; }
          if (fejl) fejl.textContent = (r && r.fejl) || 'Noget gik galt — prøv igen';
          knap.disabled = false;
          knap.textContent = 'Gem';
        })
        .catch(function () {
          if (fejl) fejl.textContent = 'Noget gik galt — prøv igen';
          knap.disabled = false;
          knap.textContent = 'Gem';
        });
    });
  }

  function adresseFormHtml(a) {
    a = a || {};
    return (
      '<div class="mtw-konto__form-grid">' +
      inputRk('Fornavn', 'first_name', a.first_name, 'autocomplete="given-name"') +
      inputRk('Efternavn', 'last_name', a.last_name, 'autocomplete="family-name"') +
      inputRk('Adresse', 'address1', a.address1, 'required autocomplete="address-line1"') +
      inputRk('Etage m.m. (valgfrit)', 'address2', a.address2, 'autocomplete="address-line2"') +
      inputRk('Postnr.', 'zip', a.zip, 'required autocomplete="postal-code" class="mtw-konto__felt--kort"') +
      inputRk('By', 'city', a.city, 'required autocomplete="address-level2"') +
      inputRk('Telefon (valgfrit)', 'phone', a.phone, 'autocomplete="tel"') +
      '</div>' +
      '<label class="mtw-konto__check"><input type="checkbox" name="set_default"' + (a.er_standard ? ' checked disabled' : '') + '> Brug som standardadresse</label>' +
      '<p class="mtw-konto__fejl" role="alert"></p>' +
      '<div class="mtw-konto__form-knapper">' +
      '<button type="submit" class="mtw-konto__knap">Gem</button>' +
      '<button type="button" class="mtw-konto__knap mtw-konto__knap--ghost" data-luk>Annullér</button>' +
      '</div>'
    );
  }

  function renderProfil(p) {
    if (!profilHolder) return;
    if (!p) {
      profilHolder.innerHTML =
        '<div class="mtw-konto__tom">Kunne ikke hente din profil lige nu.<br>' +
        '<button type="button" class="mtw-konto__knap" data-profil-provigen>Prøv igen</button></div>';
      var pk = profilHolder.querySelector('[data-profil-provigen]');
      if (pk) pk.addEventListener('click', function () { hent(); });
      return;
    }

    var navn = [p.first_name, p.last_name].filter(Boolean).join(' ') || '—';
    var html =
      '<div class="mtw-konto__kort" data-info>' +
      '<div class="mtw-konto__kort-hoved"><h3>Kontoinformation</h3>' +
      '<button type="button" class="mtw-konto__knap mtw-konto__knap--ghost" data-rediger-info>Redigér</button></div>' +
      '<dl class="mtw-konto__dl">' +
      '<div><dt>Navn</dt><dd data-vis-navn>' + esc(navn) + '</dd></div>' +
      '<div><dt>Email</dt><dd>' + esc(p.email || '—') + '</dd></div>' +
      '<div><dt>Telefon</dt><dd data-vis-telefon>' + esc(p.phone || 'Ikke angivet') + '</dd></div>' +
      '<div><dt>Adgangskode</dt><dd>••••••••&nbsp; <a class="mtw-konto__lille-link" href="https://auth.matraws.dk/konto/glemt">Skift</a></dd></div>' +
      '</dl>' +
      '<form class="mtw-konto__form mtw-konto__form--skjult" data-info-form>' +
      '<div class="mtw-konto__form-grid">' +
      inputRk('Fornavn', 'first_name', p.first_name, 'autocomplete="given-name"') +
      inputRk('Efternavn', 'last_name', p.last_name, 'autocomplete="family-name"') +
      inputRk('Telefon', 'phone', p.phone, 'autocomplete="tel" placeholder="+45 …"') +
      '</div>' +
      '<p class="mtw-konto__fejl" role="alert"></p>' +
      '<div class="mtw-konto__form-knapper">' +
      '<button type="submit" class="mtw-konto__knap">Gem</button>' +
      '<button type="button" class="mtw-konto__knap mtw-konto__knap--ghost" data-luk>Annullér</button>' +
      '</div>' +
      '</form>' +
      '</div>';

    html += '<div class="mtw-konto__kort" data-adresser><div class="mtw-konto__kort-hoved"><h3>Adresser</h3>' +
      '<button type="button" class="mtw-konto__knap mtw-konto__knap--ghost" data-tilfoej-adresse>Tilføj</button></div>';
    if (!p.adresser.length) {
      html += '<p class="mtw-konto__ordre-meta">Ingen adresser gemt endnu.</p>';
    }
    p.adresser.forEach(function (a, i) {
      var linje2 = [a.zip, a.city].filter(Boolean).join(' ');
      html +=
        '<div class="mtw-konto__adresse" data-adresse="' + i + '">' +
        '<div class="mtw-konto__adresse-tekst">' +
        (a.er_standard ? '<span class="mtw-konto__pill mtw-konto__pill--warn">Standard</span> ' : '') +
        '<strong>' + esc([a.first_name, a.last_name].filter(Boolean).join(' ')) + '</strong><br>' +
        esc(a.address1) + (a.address2 ? ', ' + esc(a.address2) : '') + '<br>' + esc(linje2) +
        '</div>' +
        '<div class="mtw-konto__adresse-knapper">' +
        '<button type="button" class="mtw-konto__lille-link" data-rediger-adresse="' + i + '">Redigér</button>' +
        (a.er_standard ? '' : '<button type="button" class="mtw-konto__lille-link" data-slet-adresse="' + i + '">Fjern</button>') +
        '</div>' +
        '<form class="mtw-konto__form mtw-konto__form--skjult" data-adresse-form="' + i + '">' + adresseFormHtml(a) + '</form>' +
        '</div>';
    });
    html += '<form class="mtw-konto__form mtw-konto__form--skjult" data-ny-adresse-form>' + adresseFormHtml(null) + '</form></div>';

    profilHolder.innerHTML = html;

    function genindlaes() { hent(); }

    var infoForm = profilHolder.querySelector('[data-info-form]');
    profilHolder.querySelector('[data-rediger-info]').addEventListener('click', function () {
      infoForm.classList.toggle('mtw-konto__form--skjult');
    });
    bindForm(infoForm, function (fd) {
      return { action: 'profil', first_name: fd.get('first_name'), last_name: fd.get('last_name'), phone: fd.get('phone') };
    }, genindlaes);

    var nyForm = profilHolder.querySelector('[data-ny-adresse-form]');
    profilHolder.querySelector('[data-tilfoej-adresse]').addEventListener('click', function () {
      nyForm.classList.toggle('mtw-konto__form--skjult');
    });
    bindForm(nyForm, function (fd) {
      return {
        action: 'adresse_opret',
        first_name: fd.get('first_name'), last_name: fd.get('last_name'),
        address1: fd.get('address1'), address2: fd.get('address2'),
        zip: fd.get('zip'), city: fd.get('city'), phone: fd.get('phone'),
        country_code: 'DK', set_default: fd.get('set_default') === 'on'
      };
    }, genindlaes);

    p.adresser.forEach(function (a, i) {
      var form = profilHolder.querySelector('[data-adresse-form="' + i + '"]');
      var redigerKnap = profilHolder.querySelector('[data-rediger-adresse="' + i + '"]');
      if (redigerKnap) redigerKnap.addEventListener('click', function () {
        form.classList.toggle('mtw-konto__form--skjult');
      });
      bindForm(form, function (fd) {
        return {
          action: 'adresse_opdater', address_id: a.id,
          first_name: fd.get('first_name'), last_name: fd.get('last_name'),
          address1: fd.get('address1'), address2: fd.get('address2'),
          zip: fd.get('zip'), city: fd.get('city'), phone: fd.get('phone'),
          country_code: a.country_code || 'DK', set_default: fd.get('set_default') === 'on'
        };
      }, genindlaes);
      var sletKnap = profilHolder.querySelector('[data-slet-adresse="' + i + '"]');
      if (sletKnap) sletKnap.addEventListener('click', function () {
        if (!window.confirm('Fjern denne adresse?')) return;
        post({ action: 'adresse_slet', address_id: a.id }).then(genindlaes);
      });
    });

    profilHolder.querySelectorAll('[data-luk]').forEach(function (k) {
      k.addEventListener('click', function () {
        k.closest('.mtw-konto__form').classList.add('mtw-konto__form--skjult');
      });
    });
  }

  /* ---------- Hent alt ---------- */
  function hent() {
    fetch(PROXY, { credentials: 'same-origin' })
      .then(function (r) {
        if (!r.ok) throw new Error('http ' + r.status);
        return r.json();
      })
      .then(function (data) {
        renderOrdrer((data && data.orders) || []);
        renderProfil(data && data.profil);
      })
      .catch(function () {
        if (ordreHolder) {
          ordreHolder.innerHTML =
            '<div class="mtw-konto__tom">Kunne ikke hente dine ordrer lige nu.<br>' +
            '<button type="button" class="mtw-konto__knap" data-ordrer-provigen>Prøv igen</button></div>';
          ordreHolder.querySelector('[data-ordrer-provigen]').addEventListener('click', function () { hent(); });
        }
        renderProfil(null);
      });
  }

  hent();
  hentEkstra();
})();
